module.exports = __webpack_public_path__ + "img/petstairs20.36e25e72.jpg";